// src/components/ReusableFilter.jsx
import React from "react";
import "../styles/layout.css";

export default function ReusableFilter({ isOpen, title = "Filters", onClose, children }) {
  if (!isOpen) return null;

  return (
    <div className="filter-overlay">
      <div className="filter-container">
        <div className="filter-header">
          <h3>{title}</h3>
          <button
            type="button"
            className="filter-close-btn"
            onClick={onClose}
            aria-label="Close filter"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div className="filter-content">
          {children}
        </div>
      </div>
    </div>
  );
}
